<ion-header>
  <ind-page-title [viewData]='{id:"consent-term-details", title: pageTitle, controls: backButton}' (onControlClick)='closepage()'></ind-page-title>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row justify-content-center>
      <!-- <ion-col *ngIf="!device.isNativeApp" size="2" class="colSpace"></ion-col> -->
      <ion-col class="orderCaptureScreenWrapper"
              [ngClass]="{'padding-ios': device.deviceFlags.ios}">
        <ion-list>
          <!-- Term Tabs -->
          <!-- <ind-section-header [viewData]="termsHeaderModel"></ind-section-header> -->
          <header>
            <ul class="tabs">
              <li *ngFor="let tab of termTabsData; let i = index; trackBy: trackById">
                <button
                  class="tab-button"
                  (click)="selectTerm(i.toString())"
                  [class.selected]="selectedTermIndex === i.toString()"
                >
                  <span class="tab-button-text">{{ tab.displayText }}</span>
                </button>
              </li>
            </ul>
          </header>

          <!-- Selected Term Details: Expires On and Signature -->
          <ion-item *ngIf="selectedTerm" lines="none" class="consent-grid">
            <ion-grid>
              <ion-row>
                <ion-col size="6">
                  <div class="display-grid">
                    <ion-text class="child-item-label">{{ 'EXPIRES_ON' | translate }}</ion-text>
                    <ion-label class="child-item-text">{{ getExpiresOnDate() }}</ion-label>
                  </div>
                </ion-col>
                <ion-col size="6">
                  <div class="display-grid">
                    <ion-text class="child-item-label">{{ 'SIGNATURE' | translate }}</ion-text>
                    <ion-label class="child-item-text">{{ getSignatureValue() }}</ion-label>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>

          <!-- Products Section -->
          <div *ngIf="authenticationService.user.isProductConsent && getSelectedTermProducts().length > 0">
            <ind-section-header [viewData]="productsHeaderModel"></ind-section-header>
            <header>
              <ul class="tabs">
                <li *ngFor="let tab of productTabsData; let i = index; trackBy: trackById">
                  <button
                    class="tab-button"
                    (click)="selectProduct(tab.value)"
                    [class.selected]="selectedProductIndex === tab.value"
                  >
                    <span class="tab-button-text">{{ tab.displayText }}</span>
                  </button>
                </li>
              </ul>
            </header>
            
            <!-- Channels under Selected Product -->
            <div *ngIf="getSelectedProductChannelValues().length > 0">
              <div class="channels-label">{{ 'CHANNELS' | translate }}</div>
              <ion-item lines="none" class="ion-no-padding">
                <div class="channel-chips-container">
                  <ion-chip 
                    *ngFor="let channel of getSelectedProductChannelValues(); let i = index; trackBy: trackById"
                    [ngClass]="{'chip-selected': selectedChannel === channel}"
                    (click)="selectChannel(channel, i)">
                    <ion-label>{{ getChannelTypeLabel(channel) }} | {{ getChannelValue(channel) }}</ion-label>
                  </ion-chip>
                </div>
              </ion-item>
              
              <!-- Channel Details -->
              <channel-detail-card
                *ngIf="selectedChannel && selectedTopics.length === 0"
                [optedInDate]="getOptedInDate(selectedChannel)"
                [optedInSource]="getOptedInSource(selectedChannel)"
                [optedOutDate]="getOptedOutDate(selectedChannel)"
                [optedOutSource]="getOptedOutSource(selectedChannel)"
                [isOptedIn]="isChannelOptedIn(selectedChannel)"
                [isOffline]="device.isOffline"
                [isOneKeySearching]="contactService.isOneKeySearching"
                [isPending]="isPending"
                [isToggleDisabled]="!isChannelOptedIn(selectedChannel) || device.isOffline || contactService.isOneKeySearching || isPending"
                (onStatusToggleClick)="handleChannelStatusToggleClick($event)"
                (onSignatureClick)="onChannelSignatureClick()">
              </channel-detail-card>
            </div>
          </div>

          <!-- Channels Section (when no products or isProductConsent is false) -->
          <div *ngIf="(getSelectedTermProducts().length === 0 || !authenticationService.user.isProductConsent) && getSelectedTermChannels().length > 0">
            <div class="separator-bar"></div>
            <div class="channels-label">{{ 'CHANNELS' | translate }}</div>
            <ion-item lines="none" class="ion-no-padding">
              <div class="channel-chips-container">
                <ion-chip 
                  *ngFor="let channel of getSelectedTermChannels(); let i = index; trackBy: trackById"
                  [ngClass]="{'chip-selected': selectedChannel === channel}"
                  (click)="selectChannel(channel, i)">
                  <ion-label>{{ getChannelTypeLabel(channel) }} | {{ getChannelValue(channel) }}</ion-label>
                </ion-chip>
              </div>
            </ion-item>
            
            <!-- Channel Details -->
            <channel-detail-card
              *ngIf="selectedChannel && selectedTopics.length === 0"
              [optedInDate]="getOptedInDate(selectedChannel)"
              [optedInSource]="getOptedInSource(selectedChannel)"
              [optedOutDate]="getOptedOutDate(selectedChannel)"
              [optedOutSource]="getOptedOutSource(selectedChannel)"
              [isOptedIn]="isChannelOptedIn(selectedChannel)"
              [isOffline]="device.isOffline"
              [isOneKeySearching]="contactService.isOneKeySearching"
              [isPending]="isPending"
              [isToggleDisabled]="!isChannelOptedIn(selectedChannel) || device.isOffline || contactService.isOneKeySearching || isPending"
              (onStatusToggleClick)="handleChannelStatusToggleClick($event)"
              (onSignatureClick)="onChannelSignatureClick()">
            </channel-detail-card>
          </div>

          <!-- Topics Section -->
          <div *ngIf="selectedChannel && selectedTopics.length > 0 && fetchRTMEnabled">
            <div class="topics-cards-container">
              <div *ngFor="let topic of selectedTopics; trackBy: trackById" class="topic-card-wrapper">
                <item-detail-card
                  [itemData]="topic"
                  [isOffline]="device.isOffline"
                  [isOneKeySearching]="contactService.isOneKeySearching"
                  [readOnly]="isPending"
                  (onSignatureClick)="onSignatureClick($event)"
                  (onStatusToggleClick)="handleStatusToggleClick($event)">
                </item-detail-card>
              </div>
            </div>
          </div>

          <ion-item *ngIf="getSelectedTermProducts().length === 0 && getSelectedTermChannels().length === 0">
            <ion-label>
              <p>{{ 'NO_PRODUCTS' | translate }}</p>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-col>
      <!-- <ion-col *ngIf="!device.isNativeApp" size="2" class="colSpace"></ion-col> -->
    </ion-row>
  </ion-grid>
</ion-content>

